/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.quote[_ngcontent-%COMP%]{background-color:var(--background-color,inherit)}.quote__author[_ngcontent-%COMP%], .quote__description[_ngcontent-%COMP%]{margin-top:20px}.quote__author[_ngcontent-%COMP%], .quote__text[_ngcontent-%COMP%]{background-color:var(--title-color,inherit)}.quote__description[_ngcontent-%COMP%]{background-color:var(--text-color,inherit)}"];
export { styles as styles };
